import { ComponentType, JSX } from 'react'

export const createComponentFn =
  <T extends JSX.IntrinsicAttributes>(Component: ComponentType<T>) =>
  (props: T) => <Component {...props} />
